'use strict';

angular.module('programme')

.component('categoryNav', {
    controller: 'CategoryNavCtrl',
    controllerAs: '$ctrl',
    templateUrl: 'modules/programme/components/categoryNav/categoryNav.html',
    bindings: {
        categories: '<',
        category: '<'
    }
})

.controller('CategoryNavCtrl', function ($scope, $state)
{
    this.hasPrev = function()
    {
        var index = this.categories.indexOf(this.category);

        if (this.categories[index - 1]) {
            return true;
        }

        return false;
    };

    this.hasNext = function()
    {
        var index = this.categories.indexOf(this.category);

        if (this.categories[index + 1]) {
            return true;
        }

        return false;
    };

    this.goPrev = function()
    {
        var index = this.categories.indexOf(this.category);
        var next = this.categories[index - 1];
        $state.go('programme.category', {categorySlug: next.slug});
    };

    this.goNext = function()
    {
        var index = this.categories.indexOf(this.category);
        var next = this.categories[index + 1];

        $state.go('programme.category', {categorySlug: next.slug});
    };

    this.title = function(direction)
    {
        var index = this.categories.indexOf(this.category);
        const newIndex = direction === 'prev' ? index - 1 : index + 1;
        return this.categories[newIndex] ? this.categories[newIndex].title : '';
    };
});
